import { Bitcoin } from 'lucide-react';
import { useDenomination } from '../contexts/DenominationContext';

export default function DenominationToggle() {
  const { denomination, toggleDenomination } = useDenomination();

  return (
    <div className="flex-none grid grid-cols-2 w-28 h-14 sm:h-12 border-2 border-[--border-color]">
      <button
        onClick={denomination === 'SATS' ? toggleDenomination : undefined}
        className={`flex items-center justify-center gap-1 py-2 px-3 font-mono text-sm ${
          denomination === 'BTC' ? 'bg-black text-white' : 'text-black bg-[--bg-secondary]'
        }`}
      >
        <span>₿</span>
        <span>BTC</span>
      </button>
      <button
        onClick={denomination === 'BTC' ? toggleDenomination : undefined}
        className={`flex items-center justify-center gap-1 py-2 px-3 font-mono text-sm ${
          denomination === 'SATS' ? 'bg-black text-white' : 'text-black bg-[--bg-secondary]'
        }`}
      >
        <span>₿</span>
        <span>SATS</span>
      </button>
    </div>
  );
}